module.exports = __webpack_public_path__ + "static/assets/cd8e77ccfefb3460408b6c3d92b1b20c.png";